export default __webpack_public_path__ + "static/media/email.9b4a041b.svg";